<template>
    <div class="d-flex">
        <vue2-date-picker
            prefix-class="xmx"
            v-model="range"
            type="date"
            range
            :class="['border rounded']"
            :clearable="false"
            :lang="lang"
            :shortcuts="options.shortcuts"
            format="DD/MM/YYYY"
            range-separator=" - "
            :disabled-date="options.disabledDate"
        >
            <div slot="icon-calendar"></div>
        </vue2-date-picker>
    </div>
</template>

<script>
import Vue2DatePicker from 'vue2-datepicker'
import '../assets/scss/datepicker.scss'

export default {
    name: 'DatePicker',
    components: { Vue2DatePicker },
    data () {
        return {
            lang: {
                formatLocale: this.$t('GENERIC.DATEPICKER'),
            },
            options: {
                disabledDate (time) {
                    return time.getTime() > Date.now()
                },
                shortcuts: [{
                    text: this.$t('GENERIC.DATEPICKER.LAST.WEEK'),
                    onClick () {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        return [start, end]
                    },
                }, {
                    text: this.$t('GENERIC.DATEPICKER.LAST.MONTH'),
                    onClick () {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                        return [start, end]
                    },
                }, {
                    text: this.$t('GENERIC.DATEPICKER.LAST.THREEMONTH'),
                    onClick () {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                        return [start, end]
                    },
                }],
            },
        }
    },
    computed: {
        range: {
            get () {
                return this.$store.getters['dashboard/range']
            },
            set (range) {
                this.$store.dispatch('dashboard/setRange', range)
            },
        },
    },
}
</script>

<style lang="scss" >
.v2-date-wrap {
    border-radius: 0;
}
.v2-picker-panel__sidebar {
    width: 150px;
}
.v2-picker-range__left-panel {
    margin-left: 150px !important;
}

.xmx-datepicker {
    min-width: 185px;
    width: 0;
    background-color: white;

    .xmx-input {
        border-radius: 0;
        border: none;
        box-shadow: none;
        cursor: pointer;
        height: 30px;
        padding: 0 10px;
        background-color: transparent;
    }
}

.xmx-datepicker-main {
    border: 1px solid #ccc;

    &.xmx-datepicker-popup {
        border-radius: 2px;

        .xmx-datepicker-sidebar {
            width: 150px;

            .xmx-btn-shortcut {
                line-height: 28px;
            }
        }

        .xmx-datepicker-content {
            border-left: none;
            margin-left: 150px;

            .xmx-calendar {
                border-left: 1px solid #edeef2;
            }
        }
    }
}
.xmx-table th {
    color: #a1a4ad;
}
.xmx-calendar-header {
    .xmx-btn-icon-double-left,
    .xmx-btn-icon-left,
    .xmx-btn-icon-double-right,
    .xmx-btn-icon-right {
        color: #a1a4ad;
    }

    .xmx-btn-current-month,
    .xmx-btn-current-year {
        font-weight: bold;

        &:hover {
            font-weight: bold;
        }
    }
}
</style>
